import { ConfirmDialog } from "@/game/play/panelControls";
import { goToApp } from "@/helpers/site";
import { useGameStore } from "@/store/gameStore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ContinueGameDialog = () => {
  const navigate = useNavigate();
  const hasGame = useGameStore((state) => state.hasGame());
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (hasGame) {
      setShowDialog(true);
    }
  }, [hasGame]);

  return (
    <ConfirmDialog
      open={showDialog}
      title="Continue Game?"
      message="You have a game in progress. Would you like to continue playing?"
      confirm="Continue"
      onConfirm={() => {
        setShowDialog(false);
        goToApp(navigate, "/play");
      }}
      onCancel={() => setShowDialog(false)}
    />
  );
};
